/**
 * Infinite scroll for the collection grid, plus a price-sort correction.
 */

// ---------------------------------------------------------------------------
// Price-sort correction. STOPGAP, not a fix.
//
// Shopify orders price-ascending on its servers using product.price_min, which
// spans sold-out variants, before the section renders. The card shows the
// cheapest BUYABLE price, so a product whose $3 white is sold out still sorts
// as $3 while displaying $8, and sits above genuinely cheaper products.
//
// This reorders cards by the price actually shown (data-card-price).
//
// LIMIT: it can only reorder what is in the DOM. On a single-page collection
// that is everything and the order comes out exactly right. Across pages it
// fixes each page internally but cannot lift a cheap product from page 2 onto
// page 1 - only removing sold-out variants at the source does that.
// ---------------------------------------------------------------------------
function sortsByPriceAscending() {
  var section = document.querySelector('[data-section-type="collection"]');
  if (!section) return false;
  try {
    // currentSortBy is already exposed in data-section-settings by the section.
    return JSON.parse(section.dataset.sectionSettings).currentSortBy === 'price-ascending';
  } catch (e) {
    return false;
  }
}

function sortByCardPrice(nodes) {
  nodes.sort(function (a, b) {
    return parseFloat(a.dataset.cardPrice || 0) - parseFloat(b.dataset.cardPrice || 0);
  });
  return nodes;
}

class InfiniteScroll extends HTMLElement {
  connectedCallback() {
    this.anchor = this.querySelector('a');
    if (!this.anchor) return;

    this.observer = new IntersectionObserver(
      entries => entries[0].isIntersecting && this.loadNextPage(),
      { rootMargin: '400px' }
    );
    this.observer.observe(this);
  }

  // The theme's filter/sort reload replaces .collection__dynamic-part wholesale.
  // Without this, the orphaned observer keeps appending stale pages.
  disconnectedCallback() {
    this.observer && this.observer.disconnect();
  }

  async loadNextPage() {
    this.observer.disconnect();

    const label = this.anchor.innerText;
    this.anchor.innerText = 'Loading...';

    // Section Rendering API instead of the full page - the same trick theme.js's
    // own _reload() uses.
    const url = new URL(this.anchor.href, location.origin);
    const section = this.closest('[data-section-type="collection"]');
    if (section) url.searchParams.set('section_id', section.dataset.sectionId);

    try {
      const response = await fetch(url, { credentials: 'same-origin' });
      if (!response.ok) throw new Error(response.status);

      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      const grid = document.querySelector('[data-product-grid]');
      const newGrid = doc.querySelector('[data-product-grid]');
      if (!grid || !newGrid) throw new Error('product grid not found');

      // Sort each batch on its own, so cards already scrolled past never jump.
      let incoming = Array.prototype.slice.call(newGrid.children);
      if (sortsByPriceAscending()) sortByCardPrice(incoming);
      grid.append(...incoming);

      const next = doc.querySelector('infinite-scroll');
      next ? this.replaceWith(next) : this.remove();
    } catch (err) {
      console.error('InfiniteScroll:', err);
      // Leave a plain working link rather than a dead button.
      this.anchor.innerText = label;
    }
  }
}

if (!customElements.get('infinite-scroll')) {
  customElements.define('infinite-scroll', InfiniteScroll);
}

document.addEventListener('DOMContentLoaded', function () {
  if (!sortsByPriceAscending()) return;
  var grid = document.querySelector('[data-product-grid]');
  if (!grid) return;
  sortByCardPrice(Array.prototype.slice.call(grid.children))
    .forEach(function (card) { grid.appendChild(card); });
});